import { Expose } from 'class-transformer'
import { IsDefined } from 'class-validator'
import { League } from '../../entity'

export class GetLeagueDTO {

    @Expose()
    @IsDefined()
    league!: League


}

